var e = /* @__PURE__ */ ((E) => (E.Authenticate = "AUTHENTICATE", E.Authorize = "AUTHORIZE", E.EndSession = "END_SESSION", E.Logout = "LOGOUT", E.ExchangeToken = "EXCHANGE_TOKEN", E.RefreshToken = "REFRESH_TOKEN", E.ResumeAuthenticate = "RESUME_AUTHENTICATE", E.RevokeToken = "REVOKE_TOKEN", E.StartAuthenticate = "START_AUTHENTICATE", E.UserInfo = "USER_INFO", E.WellKnown = "WELL_KNOWN", E))(e || {});
export {
  e as ActionTypes
};
